import {Page} from "../page/pages"
import {PagesArchitecture} from "../page/pagesArchitecture"
import {createDropdown, createItem} from "../../shared-components/common/utils/menu/menu"

/**
 * Return the menu
 * @param  {[type]} actualPage page where the user is
 * @param  {[type]} navigate    navigate function for navigation
 */
export const menuContent = (actualPage, navigate) => {
    return [
        createDropdown(
            "TITRES CESU",
            true,
            [
                createItem(actualPage, navigate, [], Page.SIMPLE_REFUND, PagesArchitecture),
                createItem(actualPage, navigate, [], Page.BARCODE_REFUND, PagesArchitecture),
                createItem(actualPage, navigate, [], Page.FILE_REFUND, PagesArchitecture),
                createItem(actualPage, navigate, [], Page.HISTORY_REFUND, PagesArchitecture),
            ],
            "RIGHT",
        ),
        createItem(actualPage, navigate, [], Page.PAYMENT_HISTORY, PagesArchitecture),
        createItem(actualPage, navigate, [], Page.TRANSFER_HISTORY, PagesArchitecture),
        createItem(actualPage, navigate, [], Page.LOGIN, PagesArchitecture, "CONNEXION"),
        createItem(actualPage, navigate, [], Page.REGISTRATION, PagesArchitecture, "INSCRIPTION"),
    ]
}
